import React, { useState } from "react";
import { saveAsDraft } from "../../Dashboard/RoofSelection/roofFunction";
import "./sideNav.css";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useSelector } from "react-redux";
import ProgressBar from "react-bootstrap/ProgressBar";

function SideNav({ active }) {
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedbackInfo, setFeedbackInfo] = useState({
    file: "",
    description: "",
    title: "",
  });
  const [draftLoader, setDraftLoader] = useState(false);
  const [show, setShow] = useState(false);
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const userType = sessionStorage.getItem("userType");
  const [tooltip, setTooltip] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [uploadProgress] = useState(0);
  const [fileType, setFileType] = useState("");
  const conUser = useSelector((state) => state?.conUser);
  const reportInfo = useSelector((state) => state?.reportInfo);
  const user = conUser?.user;

  const pathName = window.location.pathname;

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInMegabytes = file.size / (1024 * 1024); // Convert bytes to megabytes
      if (fileSizeInMegabytes <= 50) {
        setFileType(file.type.split("/")[0]);
        setThumbnail(URL.createObjectURL(file));
        setFeedbackInfo({
          ...feedbackInfo,
          file: file,
        });
      } else {
        alert("File size exceeds 50MB. Please choose a smaller file.");
        e.target.value = ""; // Clear the file input
      }
    }
  };

  const [showLogout, setShowLogout] = useState(false);
  const handleClose = () => {
    setShow(false);
    setShowLogout(false);
  };
  const navigate = useNavigate();

  const logOut = () => {
    sessionStorage.clear();
    navigate("/SignIn");
  };

  const myProject = (value) => {
    if (
      pathName === "/createProject" ||
      pathName === "/analytics" ||
      pathName === "/design" ||
      pathName === "/electrical" ||
      pathName === "/financial" ||
      pathName === "/summary"
    ) {
      setShow(true);
    } else {
      navigate(value);
    }
  };

  const noProjectSave = () => {
    const RemoveItem = [
      "projects",
      "cid",
      "customerName",
      "projectId",
      "roofPolygons",
      "structureItem",
      "myData",
      "imageSrc",
      "ImageSrc",
    ];
    RemoveItem.forEach((key) => {
      sessionStorage.removeItem(key);
    });
    navigate("/Dashboard");
  };

  return (
    <>
      <div className="nav">
        {/* Admin */}
        {userType === "admin" && (
          <div className="sideNavIcon" onClick={() => myProject("/pvx-admin")}>
            {tooltip === "admin" && (
              <h1 className="toolTip">
                <div className="sideArrow"></div>
                Admin
              </h1>
            )}
            <svg
              className={`mouse-hover ${active === "admin" ? "active" : ""}`}
              onMouseEnter={() => setTooltip("admin")}
              onMouseLeave={() => setTooltip("")}
              onClick={() => myProject("/pvx-admin")}
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <g clip-path="url(#clip0_477_1039)">
                <path
                  d="M9.63535 0H1.82285C0.817676 0 0 0.817676 0 1.82285V6.51035C0 7.51572 0.817676 8.3334 1.82285 8.3334H9.63535C10.6407 8.3334 11.4584 7.51572 11.4584 6.51035V1.82285C11.4584 0.817676 10.6407 0 9.63535 0ZM9.63535 10.4166H1.82285C0.817676 10.4166 0 11.2343 0 12.2396V23.1771C0 24.1823 0.817676 25 1.82285 25H9.63535C10.6407 25 11.4584 24.1823 11.4584 23.1771V12.2396C11.4584 11.2343 10.6407 10.4166 9.63535 10.4166ZM23.1771 16.6666H15.3646C14.3593 16.6666 13.5416 17.4843 13.5416 18.4896V23.1771C13.5416 24.1823 14.3593 25 15.3646 25H23.1771C24.1823 25 25 24.1823 25 23.1771V18.4896C25 17.4843 24.1823 16.6666 23.1771 16.6666ZM23.1771 0H15.3646C14.3593 0 13.5416 0.817676 13.5416 1.82285V12.7604C13.5416 13.7657 14.3593 14.5834 15.3646 14.5834H23.1771C24.1823 14.5834 25 13.7657 25 12.7604V1.82285C25 0.817676 24.1823 0 23.1771 0Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_477_1039">
                  <rect width="25" height="25" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        )}

        {/* Performance */}
        <div className="sideNavIcon">
          {tooltip === "Performance" && (
            <h1 className="toolTip">
              <div className="sideArrow"></div>
              Performance
            </h1>
          )}
          <svg
            className={`mouse-hover ${
              active === "Performance" ? "active" : ""
            }`}
            onMouseEnter={() => setTooltip("Performance")}
            onMouseLeave={() => setTooltip("")}
            onClick={() => myProject("/pvx-system-performance")}
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <g clip-path="url(#clip0_477_858)">
              <path
                d="M1.69482 18.612V22.6644C1.69482 22.911 1.89514 23.1164 2.14681 23.1164H5.27989C5.52642 23.1164 5.73187 22.9161 5.73187 22.6644V15.5354L3.45654 17.8107C2.97374 18.2884 2.35739 18.5658 1.69482 18.612ZM7.29327 15.4841V22.6644C7.29327 22.911 7.49358 23.1164 7.74526 23.1164H10.8783C11.1249 23.1164 11.3303 22.9161 11.3303 22.6644V18.4374C10.6164 18.422 9.94868 18.1395 9.44534 17.6361L7.29327 15.4841ZM12.8917 17.9905V22.6644C12.8917 22.911 13.092 23.1164 13.3437 23.1164H16.4768C16.7233 23.1164 16.9288 22.9161 16.9288 22.6644V14.0408L13.3386 17.631C13.1999 17.7697 13.0509 17.8878 12.8917 17.9905ZM22.2242 8.74023L18.4902 12.4742V22.6644C18.4902 22.911 18.6905 23.1164 18.9422 23.1164H22.0752C22.3218 23.1164 22.5272 22.9161 22.5272 22.6644V9.02272C22.4245 8.93541 22.3474 8.85837 22.2909 8.807L22.2242 8.74023Z"
                fill="white"
              />
              <path
                d="M24.7873 2.1247C24.6383 1.96548 24.4123 1.8833 24.1247 1.8833H24.0425C22.5838 1.95007 21.1303 2.02198 19.6716 2.08875C19.4764 2.09902 19.2094 2.10929 18.9988 2.31988C18.932 2.38665 18.8806 2.46369 18.8395 2.55614C18.6238 3.02354 18.9269 3.32657 19.0707 3.47038L19.4353 3.84019C19.687 4.097 19.9438 4.35381 20.2006 4.60548L11.3869 13.4243L7.42693 9.46432C7.19067 9.22805 6.87222 9.09451 6.53323 9.09451C6.19425 9.09451 5.88094 9.22805 5.64467 9.46432L0.369806 14.734C-0.123269 15.2271 -0.123269 16.0232 0.369806 16.5163L0.606071 16.7526C0.842335 16.9888 1.16078 17.1224 1.49977 17.1224C1.83876 17.1224 2.15206 16.9888 2.38833 16.7526L6.53323 12.6077L10.4932 16.5677C10.7295 16.8039 11.0479 16.9375 11.3869 16.9375C11.7259 16.9375 12.0392 16.8039 12.2806 16.5677L22.2243 6.624L23.3491 7.74369C23.4827 7.87723 23.6676 8.06214 23.9501 8.06214C24.0682 8.06214 24.1863 8.03132 24.3096 7.96455C24.3918 7.91832 24.4637 7.86696 24.5253 7.80533C24.7462 7.58447 24.7873 7.30198 24.7975 7.08113C24.8386 6.13607 24.8848 5.19101 24.9311 4.24081L24.9978 2.81809C25.0133 2.52019 24.9465 2.28906 24.7873 2.1247Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_477_858">
                <rect width="25" height="25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        {/* Engagement */}
        {userType === "admin" && (
          <div
            className="sideNavIcon"
            onClick={() => myProject("/pvx-user-engagement")}
          >
            {tooltip === "Engagement" && (
              <h1 className="toolTip">
                <div className="sideArrow"></div>
                Engagement
              </h1>
            )}
            <svg
              className={`mouse-hover ${
                active === "Engagement" ? "active" : ""
              }`}
              onMouseEnter={() => setTooltip("Engagement")}
              onMouseLeave={() => setTooltip("")}
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <path
                d="M12.4549 22.0883C12.3438 22.2291 12.2019 22.3426 12.0401 22.4202C11.8784 22.4977 11.701 22.5373 11.5216 22.5358H3.79077C3.42493 22.5358 3.0866 22.3774 2.85743 22.0883C2.74385 21.948 2.66367 21.7837 2.62295 21.6079C2.58224 21.432 2.58206 21.2492 2.62243 21.0733C2.83308 20.1169 3.31366 19.241 4.00716 18.5496C4.70065 17.8582 5.57794 17.3802 6.53493 17.1724C6.59326 17.1603 6.65368 17.1629 6.71077 17.1799C7.01243 17.2666 7.32744 17.3116 7.65577 17.3116C7.98493 17.3116 8.29993 17.2666 8.6016 17.1799C8.65836 17.1628 8.71847 17.1599 8.7766 17.1716C9.73381 17.3794 10.6113 17.8575 11.305 18.549C11.9986 19.2406 12.4793 20.1167 12.6899 21.0733C12.7716 21.4333 12.6841 21.8049 12.4549 22.0883Z"
                fill="white"
              />
              <path
                d="M9.36967 15.509C10.316 14.5626 10.316 13.0282 9.36967 12.0819C8.4233 11.1355 6.88893 11.1355 5.94256 12.0819C4.99619 13.0282 4.99619 14.5626 5.94256 15.509C6.88893 16.4553 8.4233 16.4553 9.36967 15.509Z"
                fill="white"
              />
              <path
                d="M22.1416 13.1789C22.0304 13.3197 21.8885 13.4333 21.7268 13.5108C21.565 13.5884 21.3877 13.6279 21.2083 13.6264H13.4783C13.1124 13.6264 12.7741 13.4681 12.5449 13.1789C12.4313 13.0387 12.3512 12.8744 12.3105 12.6985C12.2697 12.5227 12.2696 12.3399 12.3099 12.1639C12.5204 11.2074 13.001 10.3314 13.6945 9.63979C14.388 8.94821 15.2653 8.47012 16.2224 8.26227C16.2808 8.25045 16.3412 8.25332 16.3983 8.2706C16.6999 8.35644 17.0149 8.40227 17.3433 8.40227C17.6724 8.40227 17.9874 8.35644 18.2891 8.26977C18.3459 8.2529 18.406 8.25032 18.4641 8.26227C19.4213 8.47007 20.2988 8.94813 20.9924 9.63971C21.6861 10.3313 22.1668 11.2074 22.3774 12.1639C22.4591 12.5239 22.3708 12.8948 22.1416 13.1789Z"
                fill="white"
              />
              <path
                d="M19.0572 6.60174C20.0035 5.65537 20.0035 4.121 19.0572 3.17463C18.1108 2.22826 16.5764 2.22826 15.6301 3.17463C14.6837 4.121 14.6837 5.65537 15.6301 6.60174C16.5764 7.54811 18.1108 7.54811 19.0572 6.60174Z"
                fill="white"
              />
              <path
                d="M17.805 20.723H15.3175C15.0965 20.723 14.8846 20.6352 14.7283 20.4789C14.572 20.3226 14.4842 20.1106 14.4842 19.8896C14.4842 19.6686 14.572 19.4566 14.7283 19.3004C14.8846 19.1441 15.0965 19.0563 15.3175 19.0563H17.805C17.8263 19.0563 17.8466 19.0479 17.8616 19.0329C17.8766 19.0179 17.885 18.9975 17.885 18.9763V16.4455C17.885 16.2244 17.9728 16.0125 18.1291 15.8562C18.2854 15.6999 18.4974 15.6121 18.7184 15.6121C18.9394 15.6121 19.1514 15.6999 19.3076 15.8562C19.4639 16.0125 19.5517 16.2244 19.5517 16.4455V18.9763C19.5517 19.9396 18.7684 20.723 17.805 20.723ZM7.35921 9.43129C7.1382 9.43129 6.92624 9.34349 6.76996 9.18721C6.61368 9.03093 6.52588 8.81897 6.52588 8.59796V6.06712C6.52588 5.10379 7.30921 4.32129 8.27255 4.32129H10.7609C10.9819 4.32129 11.1939 4.40909 11.3501 4.56537C11.5064 4.72165 11.5942 4.93361 11.5942 5.15462C11.5942 5.37564 11.5064 5.5876 11.3501 5.74388C11.1939 5.90016 10.9819 5.98796 10.7609 5.98796H8.27255C8.25147 5.98795 8.23125 5.99627 8.21627 6.01109C8.20129 6.02592 8.19277 6.04605 8.19255 6.06712V8.59796C8.19255 8.81897 8.10475 9.03093 7.94847 9.18721C7.79219 9.34349 7.58023 9.43129 7.35921 9.43129Z"
                fill="white"
              />
            </svg>
          </div>
        )}
        {/* <img className='mouse-hover' src={people} alt='Files' /> */}
        {/* Support */}
        {userType === "admin" && (
          <div
            className="sideNavIcon"
            onClick={() => myProject("/pvx-customer-support")}
          >
            {tooltip === "Support" && (
              <h1 className="toolTip">
                <div className="sideArrow"></div>
                Support
              </h1>
            )}
            <svg
              className={`mouse-hover ${active === "Support" ? "active" : ""}`}
              onMouseEnter={() => setTooltip("Support")}
              onMouseLeave={() => setTooltip("")}
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <g clip-path="url(#clip0_477_623)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.0225 22.7163C15.0225 21.8522 14.322 21.1518 13.4579 21.1518H11.5421C11.1271 21.1518 10.7292 21.3166 10.4358 21.61C10.1424 21.9034 9.97754 22.3014 9.97754 22.7163C9.97754 23.5804 10.678 24.2809 11.5421 24.2809H13.4579C14.322 24.2809 15.0225 23.5804 15.0225 22.7163ZM3.28911 18.682C3.55044 18.702 3.8666 18.7134 4.18418 18.6948C4.38324 19.7041 4.9265 20.6131 5.7212 21.2664C6.5159 21.9197 7.51274 22.2768 8.5415 22.2769H9.13848C9.08544 22.5674 9.08531 22.8652 9.13809 23.1558H8.5415C7.27722 23.1558 6.05426 22.7055 5.09179 21.8857C4.12931 21.0659 3.49025 19.9302 3.28911 18.682ZM2.84204 17.7468C2.04745 17.6128 1.32601 17.2017 0.805742 16.5863C0.285469 15.971 3.965e-06 15.1913 0 14.3854L0 12.3082C0 11.4041 0.359133 10.5371 0.998394 9.89779C1.63766 9.25852 2.50468 8.89938 3.40874 8.89936H3.63564C3.99834 4.32144 7.82852 0.719238 12.5 0.719238C17.1715 0.719238 21.0017 4.32144 21.3644 8.89936H21.5913C22.4953 8.89938 23.3623 9.25852 24.0016 9.89779C24.6409 10.5371 25 11.4041 25 12.3082V14.3854C25 15.2895 24.6409 16.1565 24.0016 16.7958C23.3623 17.4351 22.4953 17.7942 21.5913 17.7942H20.5854C20.1682 17.7942 19.83 17.456 19.83 17.0389V9.61172C19.83 5.56348 16.5482 2.28174 12.5 2.28174C8.45176 2.28174 5.17002 5.56348 5.17002 9.61172V17.0389C5.17002 17.3334 5.00142 17.5886 4.75542 17.7132C4.07827 17.9481 3.02813 17.7782 2.84204 17.7468Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_477_623">
                  <rect width="25" height="25" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        )}
        {/* Financial */}
        {userType === "admin" && (
          <div
            className="sideNavIcon"
            onClick={() => myProject("/pvx-financial-overview")}
          >
            {tooltip === "Financial" && (
              <h1 className="toolTip">
                <div className="sideArrow"></div>
                Financial
              </h1>
            )}
            <svg
              className={`mouse-hover ${
                active === "Financial" ? "active" : ""
              }`}
              onMouseEnter={() => setTooltip("Financial")}
              onMouseLeave={() => setTooltip("")}
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <g clip-path="url(#clip0_477_1294)">
                <path
                  d="M16.9434 8.88672C12.5009 8.88672 8.88672 12.5009 8.88672 16.9434C8.88672 21.3858 12.5009 25 16.9434 25C21.3858 25 25 21.3858 25 16.9434C25 12.5009 21.3858 8.88672 16.9434 8.88672ZM16.9434 16.2109C18.155 16.2109 19.1406 17.1966 19.1406 18.4082C19.1406 19.3618 18.5265 20.1672 17.6758 20.4706V22.0703H16.2109V20.4706C15.3603 20.1672 14.7461 19.3618 14.7461 18.4082H16.2109C16.2109 18.8123 16.5393 19.1406 16.9434 19.1406C17.3475 19.1406 17.6758 18.8123 17.6758 18.4082C17.6758 18.0041 17.3475 17.6758 16.9434 17.6758C15.7317 17.6758 14.7461 16.6901 14.7461 15.4785C14.7461 14.5249 15.3603 13.7195 16.2109 13.4162V11.8164H17.6758V13.4162C18.5265 13.7195 19.1406 14.5249 19.1406 15.4785H17.6758C17.6758 15.0744 17.3475 14.7461 16.9434 14.7461C16.5393 14.7461 16.2109 15.0744 16.2109 15.4785C16.2109 15.8826 16.5393 16.2109 16.9434 16.2109ZM8.1543 8.88672C12.6719 8.88672 16.2109 6.95625 16.2109 4.49219C16.2109 2.02813 12.6719 0 8.1543 0C3.63672 0 0 2.02813 0 4.49219C0 6.95625 3.63672 8.88672 8.1543 8.88672ZM0 16.4824V17.6758C0 20.1398 3.63672 22.0703 8.1543 22.0703C8.41055 22.0703 8.65884 22.0467 8.91113 22.0344C8.34163 21.1396 7.92666 20.1554 7.68359 19.123C4.41675 19.0328 1.58018 18.029 0 16.4824ZM7.45708 17.6385C7.44028 17.4081 7.42188 17.178 7.42188 16.9434C7.42188 16.1798 7.52192 15.4409 7.69253 14.7289C4.42163 14.6402 1.58159 13.6358 0 12.0878V13.2812C0 15.6146 3.28428 17.4483 7.45708 17.6385ZM8.1543 13.2812L8.15654 13.2812C8.63629 12.1347 9.3351 11.0928 10.2138 10.214C9.55234 10.2976 8.86875 10.3516 8.1543 10.3516C4.6769 10.3516 1.65654 9.3146 0 7.69331V8.88672C0 11.3508 3.63672 13.2812 8.1543 13.2812Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_477_1294">
                  <rect width="25" height="25" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        )}
        {/* <img className='mouse-hover' src={tool} alt='Files' /> */}
        {/* Settings Icon */}
        <div className="sideNavIcon">
          {tooltip === "Settings" && (
            <h1 className="toolTip">
              <div className="sideArrow"></div>
              Settings
            </h1>
          )}
          <svg
            className={`mouse-hover`}
            onMouseEnter={() => setTooltip("Settings")}
            onMouseLeave={() => setTooltip("")}
            onClick={() => myProject("/settings")}
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              d="M14.6948 1.64123C14.0498 -0.547076 10.9502 -0.547076 10.3052 1.64123L10.1488 2.17192C9.73667 3.57016 8.13961 4.23168 6.8595 3.53439L6.37364 3.26975C4.37019 2.17846 2.17846 4.3702 3.26975 6.37364L3.53439 6.8595C4.23168 8.13962 3.57016 9.73667 2.17192 10.1488L1.64123 10.3052C-0.547076 10.9502 -0.547076 14.0498 1.64123 14.6948L2.17192 14.8512C3.57016 15.2633 4.23168 16.8604 3.53439 18.1405L3.26975 18.6264C2.17846 20.6298 4.37019 22.8215 6.37364 21.7303L6.8595 21.4656C8.13961 20.7683 9.73667 21.4298 10.1488 22.8281L10.3052 23.3588C10.9502 25.5471 14.0498 25.5471 14.6948 23.3588L14.8512 22.8281C15.2633 21.4298 16.8604 20.7683 18.1405 21.4656L18.6264 21.7303C20.6298 22.8215 22.8215 20.6298 21.7303 18.6264L21.4656 18.1405C20.7683 16.8604 21.4298 15.2633 22.8281 14.8512L23.3588 14.6948C25.5471 14.0498 25.5471 10.9502 23.3588 10.3052L22.8281 10.1488C21.4298 9.73667 20.7683 8.13962 21.4656 6.8595L21.7303 6.37364C22.8215 4.37019 20.6298 2.17847 18.6264 3.26975L18.1405 3.5344C16.8604 4.23168 15.2633 3.57016 14.8512 2.17192L14.6948 1.64123ZM12.5 17.0763C9.97259 17.0763 7.92373 15.0274 7.92373 12.5C7.92373 9.9726 9.97259 7.92373 12.5 7.92373C15.0274 7.92373 17.0763 9.9726 17.0763 12.5C17.0763 15.0274 15.0274 17.0763 12.5 17.0763Z"
              fill="white"
            />
          </svg>
        </div>
        {/* </Link> */}
        {/* Arrow */}
        <div className="sideNavIcon">
          {tooltip === "logout" && (
            <h1 className="toolTip">
              <div className="sideArrow"></div>
              Logout
            </h1>
          )}
          <svg
            className="mouse-hover"
            onMouseEnter={() => setTooltip("logout")}
            onMouseLeave={() => setTooltip("")}
            onClick={() => setShowLogout(true)}
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              d="M12.5 0C19.4036 0 25 5.59644 25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5C0 5.59644 5.59644 0 12.5 0ZM7.03125 11.7188C6.59978 11.7188 6.25 12.0685 6.25 12.5C6.25 12.9315 6.59978 13.2812 7.03125 13.2812H16.0826L12.7288 16.6351C12.4237 16.9402 12.4237 17.4348 12.7288 17.7399C13.0339 18.045 13.5286 18.045 13.8337 17.7399L18.5212 13.0524C18.8263 12.7473 18.8263 12.2527 18.5212 11.9476L13.8337 7.26007C13.5286 6.95498 13.0339 6.95498 12.7288 7.26007C12.4237 7.56517 12.4237 8.05983 12.7288 8.36493L16.0826 11.7188H7.03125Z"
              fill="white"
            />
          </svg>
        </div>
        {/* <img className='mouse-hover' src={arrow} alt='Files' /> */}
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="sideNavModal actionModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Save Changes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to stop editing? You can save this project as
          draft and can continue later.
        </Modal.Body>
        <Modal.Footer>
          {draftLoader && (
            <div className="draftLoader">
              <div className="ring"></div>
              <img src="./images/Logos/flash.svg" alt="logo"></img>
            </div>
          )}
          <Button
            variant="secondary"
            onClick={() =>
              saveAsDraft({
                setDraftLoader,
                navigate,
                roofInfo,
                quantityInfo,
                user,
                reportInfo,
              })
            }
          >
            Save as Draft
          </Button>
          <Button variant="secondary" onClick={() => noProjectSave()}>
            Don't save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showLogout}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="sideNavModal actionModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => logOut()}>
            Logout
          </Button>
          <Button variant="secondary" onClick={() => setShowLogout(false)}>
            Discard
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Feedback Modal */}
      <Modal
        show={showFeedback}
        onHide={() => setShowFeedback(false)}
        backdrop="static"
        keyboard={false}
        centered
        className="featureModal"
      >
        <Modal.Body className="feature-show-model">
          <div>
            <div className="inputs">
              <h3 className="heading" style={{ marginBottom: "-10px" }}>
                Attachment
              </h3>
              <div
                className="logo"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div className="fileBox">
                  <input
                    id="img-upload"
                    placeholder="test"
                    type="file"
                    name="img"
                    aria-labelledby="Choose Attachment"
                    // accept="image/*, video/*"
                    onChange={
                      (e) => handleFileUpload(e)
                      // uploadTest(e)
                    }
                  />
                  <span>*Upload image or video file smaller than 50MB.</span>
                </div>
                {fileType === "video" && (
                  <>
                    <video
                      src={thumbnail}
                      // src={feedbackInfo.image ? feedbackInfo.image : ""}
                      alt="NoFeedbackImage"
                      style={{ width: "300px", maxHeight: "250px" }}
                    />
                    <ProgressBar
                      now={uploadProgress}
                      variant="warning"
                      animated
                      style={{ width: "300px" }}
                      striped
                      label={`${uploadProgress}%`}
                    />
                  </>
                )}
                {fileType === "image" && (
                  <>
                    <img
                      src={thumbnail}
                      // src={feedbackInfo.image ? feedbackInfo.image : ""}
                      alt="NoFeedbackImage"
                      style={{ width: "300px", maxHeight: "250px" }}
                    />
                    <ProgressBar
                      now={uploadProgress}
                      variant="warning"
                      animated
                      style={{ width: "300px" }}
                      striped
                      label={`${uploadProgress}%`}
                    />
                  </>
                )}

                {/* <video
                  src={test}
                  // src={feedbackInfo.image ? feedbackInfo.image : ""}
                  alt="NoFeedbackImage"
                  style={{ width: "300px", maxHeight: "250px" }}
                />
                <ProgressBar
                  now={uploadProgress}
                  variant="warning"
                  animated
                  style={{ width: "300px" }}
                  striped
                  label={`${uploadProgress}%`}
                /> */}
              </div>
            </div>
            <div className="inputs">
              <h3
                className="heading"
                style={{ marginTop: "10px", marginBottom: "-10px" }}
              >
                Title
              </h3>
              <input
                type="text"
                className="inputField"
                name="description"
                value={feedbackInfo.title}
                // style={{ width: "100%", height: "100px" }}
                onChange={(e) =>
                  setFeedbackInfo({
                    ...feedbackInfo,
                    title: e.target.value,
                  })
                }
                placeholder="Feedback Title"
              />
            </div>
            <div className="inputs">
              <h3
                className="heading"
                style={{ marginTop: "10px", marginBottom: "-10px" }}
              >
                Description
              </h3>
              <textarea
                type="text"
                className="inputField"
                name="description"
                value={feedbackInfo.description}
                style={{ width: "100%", height: "100px" }}
                onChange={(e) =>
                  setFeedbackInfo({
                    ...feedbackInfo,
                    description: e.target.value,
                  })
                }
                placeholder="Describe your problem or suggestion in detail..."
              />
            </div>
          </div>

          <div className="button-pair">
            <button
              className="closeButton"
              onClick={() => setShowFeedback(false)}
            >
              Close
            </button>
            <button
              className="nextButton"
              // onClick={(e) => {
              //   submitFeedback(e);
              // }}
            >
              Submit Feedback
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SideNav;
